import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router';

import { api, unwrap } from '../api/client.js';
import { PageTitle } from '../components/Layouts.js';
import { ServiceRequestForm } from '../components/ServiceRequestForm.js';
import { useLocale } from '../components/site.js';
import { Card } from '../components/ui.js';

/** Service request as a page: the target of "Hilfe anfordern" links in e-mails. */
export function HelpRequest() {
  const { siteId = '' } = useParams();
  const { t } = useTranslation();
  const locale = useLocale();
  const [params] = useSearchParams();
  const findingId = params.get('finding') ?? undefined;
  const incidentId = params.get('incident') ?? undefined;
  const finding = useQuery({
    queryKey: ['finding', findingId, locale],
    queryFn: () =>
      unwrap(
        api.GET('/findings/{findingId}', {
          params: { path: { findingId: findingId ?? '' }, query: { locale } },
        }),
      ),
    enabled: Boolean(findingId),
  });
  return (
    <>
      <PageTitle>{t('help.title')}</PageTitle>
      <Card className="max-w-xl">
        {finding.data ? <p className="mb-4 font-medium">{finding.data.title}</p> : null}
        <ServiceRequestForm
          target={{
            siteId,
            findingId: finding.isError ? undefined : findingId,
            incidentId,
            serviceCode: params.get('service') ?? undefined,
          }}
        />
      </Card>
    </>
  );
}
